import script from "./trial2paid.vue?vue&type=script&lang=js"
export * from "./trial2paid.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__